<template lang="pug">
.control
    .smartcontrolheader(@click="openDocument()")
        font-awesome-icon(:icon="getFileType[0]" :class="getFileType[1]")
        span.title {{ getDocumentName }}
    .updatebtn(v-if="isOwner")
        aiq-button(type="primary" @click="updateDocs") {{ $t(`${baseTranslationPath}.update`) }}
    aiq-button(type="primary" class="historybtn" @click="showHistory = true") {{ $t(`${baseTranslationPath}.version_history`) }}
.updatedocs
    aiq-dialog.modal-editor(:title="$t(`${baseTranslationPath}.update_title`)"
        v-model="showUpdateModal"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        @closed="closeEditor")
        .field-container.full-width.flex-display
            .file-input
                aiq-upload.img-uploader(v-model="imageUrl"
                                :http-request="uploadImage"
                                :action="url"
                                :accept="acceptedFileType"
                                :headers="headers"
                                :show-file-list="false"
                                :multiple="false")
                    .img-uploader-add
            .file-list
                ViewFiles(:record="fileVersion" :progress="uploadProgress")
        .field-container.full-width
            label {{ $t(`${baseTranslationPath}.version`) }}
            aiq-input(v-model="version"
                        :max-length="250"
                        :placeholder="$t(`${baseTranslationPath}.version`)")
        .field-container.full-width.save-doc-btn
            aiq-button(type="primary" @click="saveDocument") {{ $t('global.save') }}
VersionHistory(:smart-control-record="smartControlRecord"
              :showHistory="showHistory"
              @closeHistory="showHistory = false"
              v-if="showHistory")
</template>
<script>
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import { iconClasses } from '../../SmartDrive/smartDriveUtil';
import { hosts } from '@/config/api.routes';
import ViewFiles from '../../SmartDrive/ViewFiles.vue';
import VersionHistory from './VersionHistory.vue';
import { IMAGE_ACL_TYPES } from '@/constants';
import get from 'lodash/get';
const COMPLETE_UPLOAD = 100;

export default {
  name: 'ControlListHeader',
  mixins: [GetGlobalSource],
  components: {
    ViewFiles,
    VersionHistory,
  },
  emits: ['update-docs'],
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      showUpdateModal: false,
      imageUrl: '',
      showHistory: false,
      url: `${hosts.management}files/upload`,
      uploadProgress: {
        uploadPercent: COMPLETE_UPLOAD,
        uploadStatus: 'success',
        progressBarStatus: 'complete',
      },
      version: '',
      acceptedFileType: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,text/csv',
      headers: {
        Authorization: this.$store.getters['agent/authToken'],
      },

    };
  },
  props: {
    smartControlRecord: {
      type: Object,
      required: true,
    },
    isOwner: {
      type: Boolean,
      required: true,
    },
    fileVersion: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.version = get(this.fileVersion, 'label', '');
  },
  computed: {
    getDocumentName() {
      return `${get(this.smartControlRecord, 'document.name', '')} (Version ${this.version})`;
    },
    getFileType() {
      const object_type = get(this.fileVersion, 'file.payload.mime', '');
      return iconClasses(object_type);
    },
    getAcl() {
      return get(this.fileVersion, 'file.payload.acl', IMAGE_ACL_TYPES.PRIVATE);
    },
  },
  methods: {
    async openDocument() {
      const url = await this.getFileUrl(get(this.fileVersion, 'file.payload'));
      if (url) {
        window.open(url, '_blank');
      }
    },
    updateDocs() {
      this.showUpdateModal = true;
    },
    saveDocument() {
      this.closeEditor();
    },
    closeEditor() {
      this.showUpdateModal = false;
    },
    onUploadProgress(progressEvent) {
      const percent = Math.round(
        (progressEvent.loaded * COMPLETE_UPLOAD) / progressEvent.total,
      );
      if (percent !== COMPLETE_UPLOAD) {
        this.uploadProgress = {
          uploadPercent: percent,
          uploadStatus: 'success',
          progressBarStatus: 'in progress',
        };
      } else {
        this.uploadProgress = {
          uploadPercent: percent,
          uploadStatus: 'success',
          progressBarStatus: 'complete',
        };
      }
    },
    async uploadImage(data) {
      const formData = new FormData();
      formData.append('file', data.file);
      formData.append('acl', this.getAcl);

      //update file temp
      this.$emit('update-docs', {
        data: {
          name: data.file.name,
          mime: data.file.type,
          url: '',
        },
      });
      try {
        const response = await this.$store.dispatch('files/upload', {
          formData,
          url: this.url,
          onUploadProgress: this.onUploadProgress,
        });
        this.$emit('update-docs', {data: response.data});
      } catch (e) {
        // handle error
        this.uploadProgress = {
          uploadPercent: COMPLETE_UPLOAD,
          uploadStatus: 'exception',
          progressBarStatus: 'failure',
        };
      }
    },
  },

};
</script>
<style lang="scss" scoped>
@import "../../SmartDrive/icon.scss";
.control {
    display: flex;
}

.historybtn {
    margin-left: 10px;
}

.flex-display {
    display: flex;
    gap: 25%;
}
.updatebtn {
    margin-left: 10px;
}

.save-doc-btn {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
}

.file-list {
  margin-bottom: 20px;
}
.smartcontrolheader {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    margin-left: 10px;
    .title {
        margin-left: 10px;
    }
    &:hover {
      color: #4671B3;
      text-decoration: underline;
      font-weight: bold;
    }
}
</style>